export default __webpack_public_path__ + "static/media/Bra-13.5e913128.svg";